import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    enquiryDetails:{},
    addCompanyUserStatus:false,
    breadCrumbStatus:false,
    listStatus:false,
    isEnquiryOrSupplierInnerComponentCLicked:false,
    requirementDetails:{},
    requirementMailMeta:{} as Record<string, { isUpdated: boolean; mailSent: boolean }>,
    venueDetails:[],
    venueDetailsEdit:false,
    supplierDetailsEdit:false,
    supplierDetails:[],
    enquiryViewState: null,
    tabIndexNumber: 0,
    toggleValue:'B2C',
    tabButtonName:'',
    selectVenueDetails:{},
    selectSupplierDetails:{},
    emailData:null,
    clientEmailData:null,
    clientFollowUpData:null,
    clientAttachmentFile:null,
    clientAttachmentStatus:false,
    supplierEmailData:null,
    followUpData:null,
    supplierFollowUpData:null,
    isSendingEmail: false,
    setEventData:"",
    setClientDownloadData:"",
    setSupplierEventData:"",
    getEventData:{},
    mailTrackDetails:[] as any[],
    eventTimings:[],
    proposalHistoryDetails:[],
    proposalModal:false,
    shortlistedVenue: [],
    SupplierShortlisted: [],
    shortlistedSupplier:{},
    getAllCompanyData: [],
    hasAssigneeChanged:false,
    xeroLoginStatus:false,
    isEditMode:false,
    uploadTemplate:{},
    totals: {
      cost: 0,
      vat: 0,
      total: 0,
      totalVat: 0,
      profitVat: 0,
    },
    getPricingDetails: {},
    proposalData: {},
    pricingRowsSelected: false,
    
};

const enquirySlice = createSlice({
  name: "enquiry",
  initialState,
  reducers: {
    SetEnquiryDetails: (state, action) => {
      state.enquiryDetails = action.payload;
    },
    setEditMode: (state) => {
      state.isEditMode = true;
    },
    clearEditMode: (state) => {
      state.isEditMode = false;
    },
    addCompanyUser: (state, action) => {
      state.addCompanyUserStatus = action.payload;
    },
    venueDataEdit: (state, action) => {
      state.venueDetailsEdit = action.payload;
    },
    supplierDataEdit: (state, action) => {
      state.supplierDetailsEdit = action.payload;
    },
    breadStatus: (state, action) => {
      state.breadCrumbStatus = action.payload;
    },
    selectListStatus: (state, action) => {
      state.listStatus = action.payload;
    },
    changeStatusOfInnerCompoenent: (state, action) => {
      state.isEnquiryOrSupplierInnerComponentCLicked = action.payload;
    },
    SetRequirementsDetails: (state, action) => {
      state.requirementDetails = action.payload;
    },
    setRequirementMailMeta: (state, action) => {
      state.requirementMailMeta = action.payload;
    },
    updateRequirementMailMeta: (state, action) => {
      const { id, ...rest } = action.payload || {};
      if (!id) return;
      const current = state.requirementMailMeta[id] || {
        isUpdated: false,
        mailSent: false,
      };
      state.requirementMailMeta[id] = {
        ...current,
        ...rest,
      };
    },
    SetVenueDetails: (state, action) => {
      state.venueDetails = action.payload;
    },
    SetSupplierDetails: (state, action) => {
      state.supplierDetails = action.payload;
    },
    setEnquiryViewState: (state, action) => {
      state.enquiryViewState = action.payload;
    },
    setEnquiryTabIndex: (state, action) => {
      state.tabIndexNumber = action.payload;
    },
    changetoggleValue: (state, action) => {
      state.toggleValue = action.payload;
    },
    setEnquiryTabButtonName: (state, action) => {
      state.tabButtonName = action.payload;
    },
    setSelectedVenueDetails: (state, action) => {
      state.selectVenueDetails = action.payload;
    },
    setSelectedSupplierDetails: (state, action) => {
      state.selectSupplierDetails = action.payload;
    },
    setEmailData: (state, action) => {
      state.emailData = action.payload;
    },
    setClientMailData: (state, action) => {
      state.clientEmailData = action.payload;
    },
    setClientFollowUpData: (state, action) => {
      state.clientFollowUpData = action.payload;
    },
    setAttachmentFile: (state, action) => {
      state.clientAttachmentFile = action.payload;
    },
    attachmentStatus: (state, action) => {
      state.clientAttachmentStatus = action.payload;
    },
    setSupplierEmailData: (state, action) => {
      state.supplierEmailData = action.payload;
    },
    setFollowUpData: (state, action) => {
      state.followUpData = action.payload;
    },
    setSupplierFollowUpData: (state, action) => {
      state.supplierFollowUpData = action.payload;
    },
    getUpdateEventData: (state, action) => {
      state.getEventData = action.payload;
    },
    getMailTrackDetails: (state, action) => {
      // state.mailTrackDetails = [...state.mailTrackDetails, ...action.payload];
      state.mailTrackDetails = action.payload;
    },
    setUpdateEventData: (state, action) => {
      state.setEventData = action.payload;
    },
    setClientDownloadData: (state, action) => {
      state.setClientDownloadData = action.payload;
    },
    setUpdateEventSupplierData: (state, action) => {
      state.setSupplierEventData = action.payload;
    },
    startSendingEmail: (state) => {
      state.isSendingEmail = true;
    },
    emailSent: (state) => {
      state.isSendingEmail = false;
    },
    getAllEventTimings: (state, action) => {
      state.eventTimings = action.payload;
    },
    getAllProposalHistoryDetails: (state, action) => {
      state.proposalHistoryDetails = action.payload;
    },
    viewProposalModal: (state, action) => {
      state.proposalModal = action.payload;
    },
    getShortlistedVenue:(state,action)=>{
      state.shortlistedVenue=action.payload
    },
    getConfirmedSupplierShortlisted:(state,action)=>{
      state.SupplierShortlisted=action.payload
    },
    getShortlistedSupplier:(state,action)=>{
      state.shortlistedSupplier=action.payload
    },
    getAllCompanyDetails:(state,action)=>{
      state.getAllCompanyData=action.payload
    },
    deleteShortlistedVenueFromState: (state, action) => {
      state.shortlistedVenue = state.shortlistedVenue.filter(
        (e:any) => e?._id !== action.payload
      );
    },
    deleteShortlistedSupplierFromState: (state, action) => {
      state.SupplierShortlisted = state.SupplierShortlisted.filter(
        (e:any) => e?._id !== action.payload
      );
    },
    updateEventAndEnquiryTable:(state,action)=>{
      state.hasAssigneeChanged=action.payload
    },
    xeroStatus:(state,action)=>{
      state.xeroLoginStatus=action.payload
    },
    uploadClientTemplate:(state,action)=>{
      state.uploadTemplate=action.payload
    },
    setTotals: (state, action) => {
      state.totals = action.payload;
    },
    setGetPricingDetails: (state, action) => {
      state.getPricingDetails = action.payload;
    },
    setProposalData: (state, action) => {
      state.proposalData = action.payload;
    },
    setPricingRowsSelected: (state, action) => {
      state.pricingRowsSelected = Boolean(action.payload);
    },
  },
});

export const {SetEnquiryDetails,setEditMode,venueDataEdit,supplierDataEdit,clearEditMode,addCompanyUser,breadStatus,changeStatusOfInnerCompoenent,SetRequirementsDetails,setRequirementMailMeta,updateRequirementMailMeta,selectListStatus,
  SetSupplierDetails,SetVenueDetails,setEnquiryViewState,setEnquiryTabIndex,changetoggleValue,setEnquiryTabButtonName,setSelectedSupplierDetails,setSelectedVenueDetails,
  setEmailData, startSendingEmail, emailSent,setUpdateEventData,getUpdateEventData,getMailTrackDetails,setFollowUpData,setSupplierEmailData,setUpdateEventSupplierData,
  setSupplierFollowUpData,getAllEventTimings,getAllProposalHistoryDetails,viewProposalModal,setClientDownloadData ,xeroStatus, getShortlistedVenue,uploadClientTemplate,
  deleteShortlistedVenueFromState,deleteShortlistedSupplierFromState,getConfirmedSupplierShortlisted,getAllCompanyDetails,setClientMailData,setAttachmentFile,attachmentStatus,setClientFollowUpData,updateEventAndEnquiryTable,getShortlistedSupplier,setGetPricingDetails,setTotals,setProposalData,setPricingRowsSelected} = enquirySlice.actions;

export default enquirySlice.reducer;
